import { projectFirestore } from '../../firebase/config'
import { useParams, Link } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { useTheme } from '../../hooks/useTheme'

// styles
import './Project.css'

export default function Project() {
    const { id } = useParams()
    const { mode } = useTheme()

    const [project, setProject] = useState(null)
    const [isPending, setIsPending] = useState(false)
    const [error, setError] = useState(false)


    useEffect(()=> {
        setIsPending(true)

        projectFirestore.collection('projects').doc(id).get().then((doc) => {
            if (doc.exists) {
                setIsPending(false)
                setProject(doc.data())
            } else {
                setIsPending(false)
                setError('Could not find that entry')
            }
        })

    }, [id])


    return (
        <div className={`project ${mode}`}>
            {error && <p className='error'>{error}</p>}
            {isPending && <p className='loading'>Loading...</p>}
            {project && (
                <>
                    <div className='breadcrumbs'>
                        <Link to="/">
                            <div className='link-crumb'>/Home </div>
                        </Link>
                        <Link to="/portfolio">
                            <div className='link-crumb'> /Portfolio </div>
                        </Link>
                        <div className='link-crumb'> /{project.title}</div>
                    </div>
                    <h2 className='page-title'>{project.title}</h2>
                    <img src={project.icon} alt={`${project.title} icon`} className='icon'/>
                    <p>{project.date}</p>
                    {project.wip && 
                    <h4>{project.wip}</h4>}
                    {project.team &&
                    <div className='row'>
                        <h4>Team Members:</h4>
                        <p>{project.team}</p>
                    </div>}
                    {project.tech &&
                    <div className='row'>
                        <h4>Tech Stack:</h4>
                        <p>{project.tech}</p>
                    </div>}
                    {project.subtitle &&
                    <h4>{project.subtitle}</h4>
                    }
                    {project.description &&
                    project.description.map((item, num)=>
                    <div key={num} className='image-container'>
                        <p>{item.text}</p>
                        <img src={item.image} alt={`${project.title} image ${num + 1}`}/>
                    </div>)}
                    {project.youtube_id &&
                    <div>
                        <h4>{project.youtube_title}</h4>
                        <iframe className='video'
                                title='Youtube player'
                                sandbox='allow-same-origin allow-forms allow-popups allow-scripts allow-presentation'
                                src={`https://youtube.com/embed/${project.youtube_id}?autoplay=0`}>
                        </iframe>
                    </div>}
                </>
            )}
             <Link to="/portfolio">
                <div className='link'>&#8592; Back to all Projects</div>
            </Link>
        </div>
    )
}